// deps
import React from "react";
import PropTypes from "prop-types";
import { css, StyleSheet } from "aphrodite";

// components
import Text from "../../../Text2";

const styles = StyleSheet.create({
  element: {
    display: "flex",
  },
  color: {
    width: "0.875rem",
    height: "0.875rem",
    borderStyle: "solid",
    borderWidth: "0.0625rem",
    borderColor: "#cfdadd",
    marginRight: "0.3125rem",
  },
  text: {
    fontSize: "0.75rem",
  },
});

function BookingDatePickerLegendElement(props) {
  const { backgroundImage, text } = props;

  return (
    <div className={css(styles.element)}>
      <div className={css(styles.color)} style={{ backgroundImage }}></div>

      <Text aStyle={styles.text}>{text}</Text>
    </div>
  );
}

BookingDatePickerLegendElement.propTypes = {
  backgroundImage: PropTypes.string,
  text: PropTypes.string,
};

export default BookingDatePickerLegendElement;
